export function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const regex = new RegExp(`${name}=([^;]+)(?:;|$)`);
  const match = document.cookie.match(regex);
  return match?.[1] ?? undefined;
}

export function setCookie(name: string, value: string, days = 365) {
  if (typeof document === "undefined") return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}
